<div class="position-relative w-100" style="height: 258px">
    <div style="height: 30px">
        @if (activityMode === 'table') {
            <label (click)="reflowChart()" style="padding-left: 100px">
                {{ graphConfig.tableTitle }}
            </label>
        }
        <div class="float-end">
            <label>
                <input
                    (ngModelChange)="activityModeChanged('graph')"
                    [ngModel]="activityMode"
                    type="radio"
                    value="graph"
                />
                Graph
            </label>
            <label style="padding-left: 20px">
                <input
                    (ngModelChange)="activityModeChanged('table')"
                    [ngModel]="activityMode"
                    type="radio"
                    value="table"
                />
                Table
            </label>
        </div>
    </div>
    @if (graphConfig && activityMode === 'graph') {
        <highcharts-column [config]="graphConfig"> </highcharts-column>
    }
    @if (graphConfig && activityMode === 'table') {
        <activity-table [config]="graphConfig" [originalConfig]="config()" [parcelId]="parcelId()"> </activity-table>
    }
</div>
